export const CALLBACK_URL = {
	URL: 'http://itracsys.kamamedical.ie:100/sage',
  CLIENT_ID: 'e418ef4e-c5be-467b-9a90-b17d78d53656/8d412104-61c8-4106-823d-5c22e2629490',
  INVOICE_URL: 'http://itracsys.kamamedical.ie:100/sage_invoice',
  INVOICE_CLIENT_ID: 'e418ef4e-c5be-467b-9a90-b17d78d53656/0f75de84-3acd-495e-9a80-58b3914658b5',
}
